<script lang="ts" setup>
const data = await useLayout();
</script>

<template>
  <footer v-if="data" class="bg-footer font-light text-white">
    <UContainer class="flex flex-col gap-10 py-10">
      <div class="flex h-fit flex-wrap gap-y-4xl sm:gap-y-7xl">
        <FooterLinkColumn v-for="linkColumn in data.linkColumn" :key="linkColumn.optTitle!" :data="linkColumn" />
        <FooterLogoList :logos="data.logoItems" />
      </div>
      <hr class="border-t-1 border-blue-900">
      <FooterBottom />
    </UContainer>
    <ResponsiveSizeBadge />
  </footer>
</template>

<style scoped></style>
